import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import mixin from '../../../utils/mixin';

import './LotDetails.scss';

const {methods} = mixin;

class LotDetails extends Component {

  constructor(props) {
      super(props)
  }

  renderName(){
    if(this.props.lot){
      return this.props.lot.name
    }
  }

  renderStatusLabel = () => {
    if(this.props.lot){
      const object = this.props.lot;
      
      let status =  this.props.status_array ? this.props.status_array.find(x => x.key == object.status) : null;
      let label = status ? status.label : '-';

      let color = this.getFillColor(object);
      color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';

      return (
        //<span style={{backgroundColor: color, color:'white', fontSize:'12px', padding:'3px', borderRadius:'5px'}}>{label}</span>
        <div className="lot-status-label">
          <span className="status-indicator" style={{backgroundColor: color}}></span> <span>{label}</span>
        </div>
      )
    }
    return '';
  }

  getFillColor(p){
    let status =  this.props.status_array ? this.props.status_array.find(x => x.key == p.status) : null;
    
    if(status){
      return [status.red,status.green,status.blue];
    }
    
    return [108,117,125];
    
  }

  getMetadata(k, v){
    let label = '';
    let sufix = '';
    switch(k){
      case 'AREA': label = 'Área'; sufix = ' m2'; break;
      case 'AREA_HA': label = 'Área'; sufix = ' ha'; break;
      case 'PERIMETER': label = 'Perímetro'; sufix = ' m2'; break;
      case 'FRONT': label = 'Frente'; sufix = ' m'; break;
      case 'DEPTH': label = 'Fondo'; sufix = ' m'; break;
      case 'FASE': label = 'Fase'; sufix = ''; break;
      case 'FEATURES': label = 'Características'; sufix = ''; break;
      case 'NOTES': label = 'Notas'; sufix = ''; break;
      case 'PRICE_M2': label = 'Precio m2'; v = '$ ' + v; sufix = ' MXN'; break;
      case 'PROMO': label = 'Promoción'; sufix = ''; break;
    }
    if(v){
      return (
        <Col sm="6" key={k}><span className="label">{label}:</span> <span className="val">{v} {sufix}</span><br/></Col>
      )
    }
    return null;
  }

  renderDetails = () => {
    if(this.props.lot){
      return (
        <div className="row">
          { this.props.development &&
            this.props.development.is_vertical &&
            this.props.lot.story_number &&
            <Col sm="6" ><span className="label">Piso:</span> <span className="val">{this.props.lot.story_number}</span><br/></Col>
          }
          { this.props.development &&
            !this.props.development.is_vertical &&
            this.props.lot.block &&
            <Col sm="6" ><span className="label">Manzana:</span> <span className="val">{this.props.lot.block}</span><br/></Col>
          }
          { this.props.lot.number &&
            <Col sm="6" ><span className="label">Número:</span> <span className="val">{this.props.lot.number}</span><br/></Col>
          }
        </div>
      );
    }
    return '';
  }

  renderSimplePriceAmount = (price) => {
    if(price){
      return(
        methods.G_renderPrice(price, 'MXN')
      )
    }
    return(
      '-'
    )
  }

  renderMetadata(){
    if(this.props.lot){
      const listMetadata = this.props.lot.metadata.map((i) => { 
        for (const [key, value] of Object.entries(i)) {
          return this.getMetadata(key, value)
        }
      });

      let meta = [];
      for(let j = 0; j < this.props.lot.metadata.length; j++){
        for (const [key, value] of Object.entries(this.props.lot.metadata[j])) {
          meta[key] = value;
        }
      }

      let area = meta['AREA'] ? meta['AREA'] : null;
      let price_m2 = meta['PRICE_M2'] ? meta['PRICE_M2'] : null;
      let lot_price = null;
      if(area != '-' && price_m2 != null){
        lot_price = parseFloat(area) * parseFloat(price_m2);
        lot_price = lot_price.toFixed(2);
      }

      return (
        <div className="row">
          {listMetadata}
          { lot_price && 
            <Col sm="6"><span className="label">Precio Lote:</span> <span className="val">{this.renderSimplePriceAmount(lot_price)}</span><br/></Col>
          }
        </div>
      );
    }
  }

  renderPrice(){
    if(this.props.lot && this.props.lot.price){
      if(this.props.lot.discount && this.props.lot.discount > 0){
        return(
          <div className="row">
            <Col xs="12">
              <div className="price-row"><span className="label">Reserva con:</span> <span className="val">{methods.G_renderPrice(this.props.lot.price, 'MXN')}</span></div>
            </Col>
            <Col xs="12">
              <div className="price-row"><span className="label">Descuento:</span> <span className="val">-{methods.G_renderPrice(this.props.lot.discount, 'MXN')}</span></div>
            </Col>
            <Col xs="12">
              <div className="price-row"><span className="label">Final:</span> <span className="val">{methods.G_renderPrice(this.props.lot.price - this.props.lot.discount, 'MXN')}</span></div>
            </Col>
          </div>
        )
      }else{
        return(
          <div className="row">
            <Col xs="12">
              <div className="price-row"><span className="label">Reserva con:</span> <span className="val">{methods.G_renderPrice(this.props.lot.price, 'MXN')}</span></div>
            </Col>
          </div>
        )
      }
    }
  }

  componentDidMount() {
  }

  renderReservationBtn = () => {
    if(this.props.lot.status == 'AVAILABLE'){
      return (
        <button className="btn btn-cust-blue float-right" onClick={this.props.reserve}>Reservar</button>
      );
    }
    return null;
  }
  
  render() {
    return(
       <div className="container pb-5">
          <button className="btn btn-danger btn-sm close-drawer-btn" onClick={this.props.close}>X</button>
          <h3 className="lot-name">{this.renderName()}</h3>
          {this.renderStatusLabel()}
          <div className="clearBoth"></div>
          <hr />
          {this.renderDetails()}
          <hr />
          {this.renderMetadata()}
          {this.props.lot && this.props.lot.metadata && this.props.lot.metadata.length > 0 && 
            <hr/>
          }
          {this.renderPrice()}
          <br/>
          {this.renderReservationBtn()}
       </div>
    )
  }

}

export default LotDetails;
